export const DELETE_STEP = 'DELETE_STEP';
